const textures = {
  name: "Textures",
  prompts: [
    "Angular",
    "Abrasive",
    "Affordable",
    "Arid",
    "Bald",
    "Blistered",
    "Bouncy",
    "Ballooned",
    "Bloated",
    "Bristly",
    "Bumpy",
    "Barbed",
    "Blunt",
    "Broad",
    "Burning",
    "Bubbly",
    "Burnished",
    "Bulging",
    "Bushy",
    "Blemished",
    "Clean",
    "Carved",
    "Clear",
    "Corduroy",
    "Crenelated",
    "Corrugated",
    "Crocheted",
    "Channelled",
    "Coagulated",
    "Cosy",
    "Crude",
    "Chapped",
    "Coarse",
    "Cottony",
    "Cushioned",
    "Cheap",
    "Coated",
    "Cold",
    "Covering",
    "Chunky",
    "Cratered",
    "Damaged",
    "Dirty",
    "Dripping",
    "Damp",
    "Dehydrated",
    "Discolourated",
    "Dry",
    "Dank",
    "Dense",
    "Dented",
    "Ductile",
    "Decorated",
    "Downy",
    "Dull",
    "Deep",
    "Durable",
    "Defective",
    "Drenched",
    "Dusty",
    "Enameled",
    "Engraved",
    "Elastic",
    "Encrusted",
    "Emblazoned",
    "Etched",
    "Embossed",
    "Fatty",
    "Flawless",
    "Feathery",
    "Fizzy",
    "Fleecy",
    "Frigid",
    "Fiery",
    "Flaky",
    "Fluffy",
    "Frothy",
    "Fluted",
    "Furred",
    "Filthy",
    "Foamy",
    "Furry",
    "Flattened",
    "Freezing",
    "Fuzzy",
    "Flawed",
    "Gelatinous",
    "Gooey",
    "Gravelly",
    "Gritty",
    "Glassy",
    "Gossamer",
    "Grimy",
    "Grooved",
    "Glazed",
    "Grainy",
    "Grinding",
    "Grubby",
    "Glossy",
    "Granular",
    "Grungy",
    "Glutinous",
    "Hairy",
    "Hatched",
    "Hoarse",
    "Hazy",
    "Honeyed",
    "Hot",
    "Hygienic",
    "Icy",
    "Imprinted",
    "Inflexible",
    "Inlaid",
    "Ironed",
    "Immaculate",
    "Inscribed",
    "Irregular",
    "Impenetrable",
    "Itchy",
    "Imperfect",
    "Indented",
    "Ivory",
    "Inflated",
    "Jagged",
    "Keen",
    "Knitted",
    "Layered",
    "Lustrous",
    "Lined",
    "Lustreless",
    "Moist",
    "Mushy",
    "Metallic",
    "Mosaic",
    "Muted",
    "Matte",
    "Mucky",
    "Mutilated",
    "Ornamented",
    "Padded",
    "Pitted",
    "Printed",
    "Pleated",
    "Polished",
    "Protected",
    "Patinated",
    "Potholed",
    "Patterned",
    "Pockmarked",
    "Pressed",
    "Pulpy",
    "Piercing",
    "Pointed",
    "Prickly",
    "Ragged",
    "Refined",
    "Ridged",
    "Runny",
    "Reflective",
    "Rigid",
    "Rutted",
    "Raw",
    "Ribbed",
    "Rough",
    "Sandy",
    "Stained",
    "Sanitary",
    "Snug",
    "Stamped",
    "Saturated",
    "Sheer",
    "Soaked",
    "Steamed",
    "Scalding",
    "Shielded",
    "Soaking",
    "Scaled",
    "Shiny",
    "Soapy",
    "Sterile",
    "Scarred",
    "Shipshape",
    "Sodden",
    "Stiff",
    "Scorching",
    "Silky",
    "Soft",
    "Scored",
    "Soggy",
    "Scraped",
    "Skin",
    "Soiled",
    "Stodgy",
    "Scratched",
    "Sleek",
    "Solid",
    "Scratching",
    "Slick",
    "Stubbly",
    "Scratchy",
    "Sculptured",
    "Slimy",
    "Sparkling",
    "Searing",
    "Slippery",
    "Serrated",
    "Spikey",
    "Swollen",
    "Smooth",
    "Syrupy",
    "Severe",
    "Spongy",
    "Shaggy",
    "Smoothed",
    "Sharp",
    "Smudged",
    "Springy",
    "Tarnished",
    "Thorny",
    "Tessellated",
    "Toothed",
    "Tweed",
    "Thick",
    "Tidy",
    "Tough",
    "Thin",
    "Tiled",
    "Translucent",
    "Unadulterated",
    "Untarnished",
    "Unblemished",
    "Unctuous",
    "Untidy",
    "Unbreakable",
    "Understated",
    "Unyielding",
    "Uncomfortable",
    "Uneven",
    "Untainted",
    "Vague",
    "Velvety",
    "Viscous",
    "Varnished",
    "Veneered",
    "Warm",
    "Woollen",
    "Waterlogged",
    "Wide",
    "Wavy",
    "Wet",
    "Withered",
    "Wooden",
    "Woven",
  ],
};

export default textures;
